import React from 'react';

export function Table({ children, className = '' }) {
  return (
    <div className="overflow-x-auto">
      <table className={`min-w-full divide-y divide-gray-200 ${className}`}>
        {children}
      </table>
    </div>
  );
}

export function TableHead({ children, className = '' }) {
  return (
    <th
      className={`
        px-6 py-3 text-left text-xs font-semibold
        text-gray-700 uppercase tracking-wider
        ${className}
      `}
    >
      {children}
    </th>
  );
}

export function TableHeader({ children }) {
  return (
    <thead className="bg-gray-100">
      {children}
    </thead>
  );
}

export function TableBody({ children }) {
  return (
    <tbody className="bg-white divide-y divide-gray-200">
      {children}
    </tbody>
  );
}

export function TableRow({ children, onClick, hover, className = '' }) {
  return (
    <tr
      className={`
        ${onClick ? 'cursor-pointer' : ''}
        ${hover ? 'hover:bg-gray-50' : ''}
        transition-colors
        ${className}
      `}
      onClick={onClick}
    >
      {children}
    </tr>
  );
}

export function TableCell({ children, className = '' }) {
  return (
    <td className={`px-6 py-4 whitespace-nowrap text-sm text-gray-900 ${className}`}>
      {children}
    </td>
  );
}
